module.exports = __webpack_public_path__ + "img/192e53a.png";